import { FC } from "react";
import { useRecoilValue } from "recoil";

import { RASTER_LANDINGS } from "@ryde/assets-landings";
import {
  landingActiveStepErrorsAtom,
  LandingStepErrorsEnum,
} from "@ryde/utils-landings";

import {
  GeneralError,
  PassengerAlreadyRegisteredError,
} from "../../errors-template";

export const StepErrorWix: FC = () => {
  const activeStepErrors = useRecoilValue(landingActiveStepErrorsAtom);
  const { type } = activeStepErrors ?? {};

  let ErrorContentMap;
  switch (type) {
    case LandingStepErrorsEnum.GeneralError:
      ErrorContentMap = <GeneralError />;
      break;
    case LandingStepErrorsEnum.PassengerAlreadyRegistered:
      ErrorContentMap = <PassengerAlreadyRegisteredError />;
      break;
    default:
      ErrorContentMap = null;
  }

  return (
    <>
      <div className="landing-top-illustration">
        <img src={RASTER_LANDINGS.CarFestImagePNG} alt="Car fest" />
      </div>
      {ErrorContentMap}

      <div className="landing-container-footer">
        <div className="landing-container-footer-logo">
          <img
            className="landing-logo__img"
            src={RASTER_LANDINGS.RideLogoPNG}
            alt="Ryde logo"
            width="120"
            height="51"
          />
        </div>
      </div>
    </>
  );
};
